import React, { useState } from "react";
import { Navbar as BootstrapNavbar, Container, Nav } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import styles from "./style.module.css";
import Logo from "../../../assets/logos/simsim_logo_black.png";
import { generateImageAltText } from '../../../utils/contentOptimization';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => setExpanded(false);

  return (
    <BootstrapNavbar
      expand="lg"
      className={styles.navbarCustom}
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <BootstrapNavbar.Brand 
          as={Link} 
          to="/" 
          onClick={handleNavClick} 
          className={styles.logo}
        >
          <img
            className={styles.img}
            src={Logo}
            alt={generateImageAltText('navbar', 'SimSim logo')}
          />
          <span className={`${styles.simsim} ms-2`}>SimSim</span>
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle
          aria-controls="basic-navbar-nav"
          className={styles.customToggler}
        >
          {expanded ? <FaTimes size={24} /> : <FaBars size={24} />}
        </BootstrapNavbar.Toggle>
        <BootstrapNavbar.Collapse id="basic-navbar-nav" className={styles.navbarCollapse}>
          <Nav className={`ms-auto ${styles.links}`}>
            <Nav.Link as={NavLink} to="/" onClick={handleNavClick} className={styles.navLink}>
              Nömrələr
            </Nav.Link>
            <Nav.Link as={NavLink} to="/stores" onClick={handleNavClick} className={styles.navLink}>
              Dilerlərimiz
            </Nav.Link>
            <Nav.Link as={NavLink} to="/catalog" onClick={handleNavClick} className={styles.navLink}>
              Rəqəmsal Kataloq
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" onClick={handleNavClick} className={styles.navLink}>
              Haqqımızda
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/contact"
              onClick={handleNavClick}
              className={`${styles.navLink} ${styles.buttonJoin}`}
            >
              Qoşul & Əlaqə
            </Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
